import useService from '@/lib/hooks/useService';
import CategoryMenu from '@/types/database/categoryMenu';
import { ResidentAccountNumber } from '@/types/database/residentAccountNumbers';
import { generateHouseHoldNumberCascader } from '@/utils/generateHouseHoldNumberCascader';

export const useOptions = () => {
  const [accountNumbers] = useService<ResidentAccountNumber>({
    collectionName: 'residentAccountNumbers',
  });

  const householdNumberOptions = generateHouseHoldNumberCascader(
    accountNumbers.map((accountNumber) => accountNumber.householdNumber)
  );

  const [categories,updateCategories] = useService<CategoryMenu>({
    collectionName: 'categoryMenu',
    query: { service: 'feedback' },
  });
  const typeOptions: { label: string; value: string }[] = [];

  categories?.[0]?.data?.forEach((category: unknown) => {
    if (typeof category === 'string') {
      typeOptions.push({ label: category, value: category });
    }
  });

  return {
    householdNumberOptions,
    typeOptions,
    updateCategories,
  };
};
